import React__default from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { StarIcon, UnstarredIcon } from '../../icons/icons.esm.js';

const useStyles = makeStyles(
  () => ({
    icon: {
      color: "#f3ba37",
      cursor: "pointer",
      display: "inline-flex"
    },
    iconBorder: {
      color: "inherit",
      cursor: "pointer",
      display: "inline-flex"
    }
  }),
  { name: "BackstageFavoriteToggleIcon" }
);
function FavoriteToggleIcon(props) {
  const { isFavorite } = props;
  const classes = useStyles();
  return /* @__PURE__ */ React__default.createElement(
    Typography,
    {
      component: "span",
      className: isFavorite ? classes.icon : classes.iconBorder
    },
    isFavorite ? /* @__PURE__ */ React__default.createElement(StarIcon, null) : /* @__PURE__ */ React__default.createElement(UnstarredIcon, null)
  );
}
function FavoriteToggle(props) {
  const {
    id,
    title,
    isFavorite: value,
    onToggle: onChange,
    ...iconButtonProps
  } = props;
  return /* @__PURE__ */ React__default.createElement(Tooltip, { id, title }, /* @__PURE__ */ React__default.createElement(
    IconButton,
    {
      "aria-label": title,
      id,
      onClick: () => onChange(!value),
      color: "inherit",
      ...iconButtonProps
    },
    /* @__PURE__ */ React__default.createElement(FavoriteToggleIcon, { isFavorite: value })
  ));
}

export { FavoriteToggle, FavoriteToggleIcon };
//# sourceMappingURL=FavoriteToggle.esm.js.map
